import { Pipe, PipeTransform } from '@angular/core';
import { AMPM } from '../constants';

@Pipe({
  name: 'capitalize',
  standalone: false,
})
export class CapitalizeAndSpaceCamelCasePipe implements PipeTransform {
  /**
   * This takes in a string and will separate out CamelCaseWords and add spaces so they appear like Camel Case Words.
   * The one exception built into this method is that when dealing with time such as AM or PM we don't want to add a
   * space.  So if a string is "AM" or "PM" we return the string as is.
   * See spec file for more examples.
   * @param value
   */
  transform(value: string): string {
    if (value && !this.isAmOrPm(value)) {
      const regex = /[A-Z]/g;
      const newValue = value.replace(regex, ' $&');
      return newValue.charAt(0).toUpperCase() + newValue.slice(1).toString();
    } else {
      return value;
    }
  }

  /**
   * Does the value end in the valu contained in the AMPM global function.
   * @param value
   */
  isAmOrPm(value: string): boolean {
    return value
      ? !!AMPM().find(
          (ddo) => ddo.value === value.slice(-2) || ddo.value === value,
        )
      : false;
  }
}
